module.exports = __webpack_public_path__ + "static/img/team-bj2.3d33ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/team/team-bj2.png
// module id = TziI
// module chunks = 1